// @ts-nocheck 8d1763af
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import * as core from '#packages/core';
import React from 'react';
import PageSettingsFrame from '../pageSettingsFrame';

// eslint-disable-next-line react/prefer-es6-class
export default createReactClass({
  mixins: [core.mixins.editorAPIMixin],
  displayName: 'pageSettingsDesktopCommon',
  propTypes: {
    title: PropTypes.string,
    closeSettingsPanel: PropTypes.func.isRequired,
    helpId: PropTypes.string,
  },
  render() {
    return (
      <PageSettingsFrame
        helpId={this.props.helpId}
        title={this.props.title}
        closeSettingsPanel={this.props.closeSettingsPanel}
      >
        {this.props.children}
      </PageSettingsFrame>
    );
  },
});
